var assign = Object.assign.bind(Object)
module.exports = assign
module.exports.default = module.exports
